// Externe Bibliotheken
import React, { Component } from 'react';
import { DateRange, Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import { de } from 'date-fns/locale';
import 'react-date-range/dist/theme/default.css'; // theme css file

// Komponenten
import ClickOutside from '@/comp/clickOutside';

// Styles
import './styles.scss';
import { Icon } from '@/comp/icon/icon.tsx';

class ClaimDateRangePicker extends Component {
    today = new Date();
    maxDate =
        this.today.getFullYear() +
        '-' +
        String(this.today.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(this.today.getDate()).padStart(2, '0');
    state = {
        singleDate: new Date(),
        collapsed: false,
        range: [
            {
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection',
            },
        ],
        from: {},
        to: {},
        formErrors: {},
    };

    constructor(props) {
        super(props);

        this.InputTextField = this.InputTextField.bind(this);
        this.DateRangeElement = this.DateRangeElement.bind(this);

        this.state.formErrors = this.props.formErrors;

        Object.keys(props.args.question.answers).forEach((item) => {
            let answer = props.args.question.answers[item];
            if (!answer.value) {
                answer.value = '';
            }
            if (answer.name === 'von' || answer.name === 'Angabe Datum') {
                this.state.from = answer;
            } else {
                this.state.to = answer;
            }
        });
    }

    formatInput(args) {
        let input = '';
        for (let i = 0; i < args.length; i++) {
            if (!isNaN(args[i])) {
                if (input.length < 10) {
                    input += args[i];
                }
                if ((i === 1 || i === 4) && args.length - 1 !== i) {
                    input += '.';
                }
            }
        }
        return input;
    }

    autoformatTravelStart(event, inputName) {
        let $this = this;
        let retrunAllow = false;
        let e = event;
        if (e.key === 'Backspace' || e.key === 'Delete') {
            return false;
        }

        e.persist();

        let inputType;
        if (inputName.name === 'von' || inputName.name === 'Angabe Datum') {
            inputType = 'from';
        } else {
            inputType = 'to';
        }

        function format(target) {
            let output = target;

            // day
            if (target.length === 1 && parseInt(target) > 3) {
                output = '0' + target;
            }

            if (!retrunAllow && target.length === 2) {
                output = target + '.';
            }

            // month
            if (!retrunAllow && target.length === 5) {
                output = target + '.';
            }

            return output;
        }

        setTimeout(function () {
            if (e.key === '.') {
                let inputLength = $this.state[inputType].value.length;
                switch (true) {
                    case inputLength < 3:
                        $this.state[inputType].value = $this.state[inputType].value.replace(/\./g, '');
                        break;
                    case inputLength === 4:
                        $this.state[inputType].value = $this.state[inputType].value.slice(0, 2) + '.';
                        break;
                    case inputLength === 5:
                        $this.state[inputType].value = $this.state[inputType].value.slice(0, 4);
                        break;
                    case inputLength === 7:
                        $this.state[inputType].value = $this.state[inputType].value.slice(0, 6);
                        break;
                    case inputLength === 8:
                        $this.state[inputType].value = $this.state[inputType].value.slice(0, 7);
                        break;
                    case inputLength === 9:
                        $this.state[inputType].value = $this.state[inputType].value.slice(0, 8);
                        break;
                    case inputLength === 10:
                        $this.state[inputType].value = $this.state[inputType].value.slice(0, 9);
                        break;
                    default:
                        break;
                }
            }
            $this.setState((state) => {
                state[inputType].value = format($this.state[inputType].value);
                return state;
            });
        }, 0);
    }

    InputTextField(args) {
        let $this = this;
        let id = this.props.args.treeKey.replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '') + args.input.key;
        id = id.replaceAll(' ', '_');

        function placeholderHelper() {
            let placeholder = 'TT.MM.JJJJ';
            let placeholderHelper = placeholder.slice(args.input.value.length).split('.');
            let placeholderHelperString = '';
            let classes = 'hide';
            if (args.input.value.indexOf('.') > 0) {
                classes += ' expand';
            }
            placeholderHelperString += '<span class="' + classes + '">' + args.input.value + '</span>';
            Object.keys(placeholderHelper).forEach((k) => {
                placeholderHelperString +=
                    '<span class="' +
                    placeholderHelper[k].slice(0, 1).toLowerCase() +
                    '">' +
                    placeholderHelper[k] +
                    '</span>';
                if (placeholderHelper.length > parseInt(k) + 1) {
                    placeholderHelperString += '.';
                }
            });

            return (
                <div className="placeholder-helper" dangerouslySetInnerHTML={{ __html: placeholderHelperString }}></div>
            );
        }

        return (
            <div className="input-container date-selection">
                <input
                    id={id}
                    key={id}
                    type="text"
                    name={args.inputName}
                    value={args.input.value.replace(/^([\d]{2})([\d]{2})([\d]{4})$/, '$1.$2.$3')}
                    max={this.maxDate}
                    className={this.props.formErrors[args.inputName] ? 'error' : ''}
                    maxLength={10}
                    onKeyDown={(event) => {
                        this.autoformatTravelStart(event, args.input);
                    }}
                    onChange={(event) => {
                        args.input.value = this.formatInput(event.target.value);
                        if (args.isFirstInput) {
                            if (event.target.value.length === 10) {
                                if (this.state.to.value.length === 10) {
                                    let parts = event.target.value.split('.');
                                    let d1 = new Date(
                                        parseInt(parts[2], 10),
                                        parseInt(parts[1], 10) - 1,
                                        parseInt(parts[0], 10)
                                    );
                                    parts = this.state.to.value.split('.');
                                    let d2 = new Date(
                                        parseInt(parts[2], 10),
                                        parseInt(parts[1], 10) - 1,
                                        parseInt(parts[0], 10)
                                    );

                                    if (Date.parse(d1.toDateString()) > Date.parse(d2.toDateString())) {
                                        $this.state.to.value = this.state.from.value;
                                        this.setState({ to: $this.state.to });
                                    }
                                }
                            }
                        }
                        this.props.handleAnswerInputChange(event, {
                            answer: args.input,
                            treeKey: this.props.args.treeKey,
                            question: this.props.args.question,
                        });
                    }}
                />
                {placeholderHelper()}
            </div>
        );
    }

    formatDate(args) {
        let $this = this;
        let startDate =
            ('0' + args.startDate.getDate()).slice(-2) +
            '.' +
            ('0' + (args.startDate.getMonth() + 1)).slice(-2) +
            '.' +
            args.startDate.getFullYear();
        let endDate =
            ('0' + args.endDate.getDate()).slice(-2) +
            '.' +
            ('0' + (args.endDate.getMonth() + 1)).slice(-2) +
            '.' +
            args.endDate.getFullYear();

        $this.state.from.value = startDate;
        $this.state.to.value = endDate;

        this.setState({
            from: $this.state.from,
            to: $this.state.to,
        });

        this.props.handleAnswerInputChange(
            { target: { value: startDate }, persist: () => true },
            { answer: $this.state.from, treeKey: this.props.args.treeKey, question: this.props.args.question }
        );
        this.props.handleAnswerInputChange(
            { target: { value: endDate }, persist: () => true },
            { answer: $this.state.to, treeKey: this.props.args.treeKey, question: this.props.args.question }
        );
    }

    handleRangeChange(event) {
        this.setState((state) => {
            state.range = [event.selection];
        });
        this.formatDate(event.selection);
    }

    handleChange = (event) => {
        let $this = this;
        let startDate =
            ('0' + event.getDate()).slice(-2) +
            '.' +
            ('0' + (event.getMonth() + 1)).slice(-2) +
            '.' +
            event.getFullYear();
        $this.state.from.value = startDate;
        this.setState({
            singleDate: event,
            from: $this.state.from,
        });
        this.props.handleAnswerInputChange(
            { target: { value: startDate }, persist: () => true },
            { answer: this.state.from, treeKey: this.props.args.treeKey, question: this.props.args.question }
        );
    };

    toggleCollapsed() {
        this.setState((state) => {
            state.collapsed = !this.state.collapsed;
            return state;
        });
    }

    closeModal() {
        this.setState((state) => {
            state.collapsed = false;
            return state;
        });
    }

    DateRangeElement() {
        let returnAnswer = [];
        let isFirstInput = false;
        let inputNameTo;
        if (this.props.args.question.type === 'dateRange') {
            isFirstInput = true;
        }
        let inputNameFrom =
            this.props.args.treeKey.replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '') +
            '_' +
            this.props.args.question.key.replaceAll(' ', '_') +
            '_' +
            this.state.from.key;
        returnAnswer.push(
            <this.InputTextField
                key={'inputField' + this.state.from.key}
                input={this.state.from}
                inputName={inputNameFrom}
                isFirstInput={isFirstInput}
            />
        );
        if (this.props.args.question.type === 'dateRange' && this.state.to) {
            inputNameTo =
                this.props.args.treeKey.replaceAll('(', '').replaceAll(')', '') +
                '_' +
                this.props.args.question.key.replaceAll(' ', '_') +
                '_' +
                this.state.to.key;
            returnAnswer.push(
                <span key={'dateSpanField' + this.state.from.key} className="dateSpan">
                    bis
                </span>
            );
            returnAnswer.push(
                <this.InputTextField
                    key={'inputField' + this.state.to.key}
                    input={this.state.to}
                    inputName={inputNameTo}
                />
            );
        }

        return (
            <>
                <div className="date-range-wrapper">
                    {returnAnswer}
                    <Icon
                        name="calendarMonth300"
                        className="icon-calendar dateSpan"
                        size={40}
                        ariaLabel="kalender öffnen"
                        onClick={() => this.toggleCollapsed()}
                    />
                    <span className="icon-calendar dateSpan"></span>
                    <ClickOutside
                        className={`date-picker-overlay ${this.state.collapsed ? 'collapsed' : ''}`}
                        onClick={() => {
                            this.closeModal();
                        }}>
                        <Icon
                            name="close"
                            role="button"
                            className="icon-close"
                            size={24}
                            ariaLabel="kalender schließen"
                            onClick={() => this.toggleCollapsed()}
                        />
                        {this.props.args.question.type === 'dateRange' ? (
                            <DateRange
                                locale={de}
                                onChange={(event) => this.handleRangeChange(event)}
                                moveRangeOnFirstSelection={false}
                                ranges={this.state.range}
                                months={window.$browserInfo.device === 'mobile' ? 1 : 2}
                                preventSnapRefocus={true}
                                calendarFocus="backwards"
                                monthDisplayFormat="MMMM yyyy"
                                weekdayDisplayFormat="cccccc"
                                direction="horizontal"
                                maxDate={new Date()}
                            />
                        ) : (
                            <Calendar
                                className={this.state.collapsed ? 'collapsed' : ''}
                                locale={de}
                                date={this.state.singleDate}
                                months={window.$browserInfo.device === 'mobile' ? 1 : 2}
                                onChange={(event) => this.handleChange(event)}
                                direction="horizontal"
                                calendarFocus="backwards"
                                preventSnapRefocus={true}
                                maxDate={new Date()}
                            />
                        )}
                    </ClickOutside>
                </div>
                {(this.props.formErrors[inputNameFrom] || this.props.formErrors[inputNameTo]) && (
                    <p className={'error'}>Bitte geben Sie ein Datum an.</p>
                )}
            </>
        );
    }

    render() {
        return <this.DateRangeElement />;
    }
}

export default ClaimDateRangePicker;
